import { Navigate } from "react-router-dom";
import { isAuthenticated, isPlatformAdmin } from "../services/authService";

/**
 * Route guard for the platform Admin Portal. Requires auth AND the
 * is_platform_admin claim; non-operators are bounced to the dashboard. The
 * backend enforces the same via require_platform_admin (this is UX only).
 */
export default function AdminProtectedRoute({ children }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  if (!isPlatformAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
